import { render, staticRenderFns } from "./TotalRevenueGuideDialog.vue?vue&type=template&id=6b84f8d2&scoped=true"
import script from "./TotalRevenueGuideDialog.vue?vue&type=script&lang=js"
export * from "./TotalRevenueGuideDialog.vue?vue&type=script&lang=js"
import style0 from "./TotalRevenueGuideDialog.vue?vue&type=style&index=0&id=6b84f8d2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b84f8d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b84f8d2')) {
      api.createRecord('6b84f8d2', component.options)
    } else {
      api.reload('6b84f8d2', component.options)
    }
    module.hot.accept("./TotalRevenueGuideDialog.vue?vue&type=template&id=6b84f8d2&scoped=true", function () {
      api.rerender('6b84f8d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/TotalRevenueGuideDialog.vue"
export default component.exports